<template>
  <div class="main-setting-menu">
    <HeaderMenu
      :arrow="arrow"
      :title="$t('updates.appUpdates')"
      :routeBackName="routeBackName"
    />
    <div class="item" v-if="!getQuiet">
      <div v-show="showProgress" class="flex">
        <div style="width: 100%">
          <div class="content">
            <div>
              <div class="text">
                {{ processMessage }}
              </div>
              <progressBar
                :percentage="getPercentage"
                :show="show"
                loadingClass="fsloadingbar"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="getStage == ENUM_UPDATES_STAGES.UPDATES_AVAILABE">
        <p>
          {{ $t("updates.updatesAvailable").replace("%VER%", getVersion) }}
        </p>
        <div class="flex">
          <div
            v-if="false"
            class="btn btn-small mrg-right mrg-t-12"
            @click="updatesInfo = getInfo"
          >
            {{ $t("updates.whatsNew") }}
          </div>
          <div v-if="getExternalNotConnected">
            {{ $t("updates.externalDriveWarning") }}
          </div>
          <div v-if="getMultiDisk">
            <div
              class="btn btn-small mrg-right mrg-t-12"
              :class="{ disable: btnDisabled }"
              @click="updateNow(false)"
            >
              {{ $t("updates.downloadNowCurrentDisk") }}
            </div>
            <div
              class="btn btn-small mrg-right mrg-t-12"
              :class="{ disable: btnDisabled }"
              @click="updateNow(true)"
            >
              {{ $t("updates.downloadNowAllDisks") }}
            </div>
          </div>
          <div v-else>
            <div class="btn btn-small mrg-right mrg-t-12" @click="updateNow">
              {{ $t("updates.downloadNow") }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="getStage == ENUM_UPDATES_STAGES.READY">
        <div>{{ $t("updates.restartMsg") }}</div>
        <div class="flex">
          <div class="btn btn-small mrg-right mrg-t-12" @click="restartApp">
            {{ $t("updates.restart") }}
          </div>
          <div class="btn btn-small mrg-right mrg-t-12" @click="close">
            {{ $t("updates.restartLater") }}
          </div>
        </div>
      </div>
      <div v-if="getStage == ENUM_UPDATES_STAGES.ERROR">
        <div>{{ $t("updates.errorMsg") }}</div>

        <div class="btn btn-small mrg-right mrg-t-12" @click="openErrorLog">
          {{ $t("support.openLogFile") }}
        </div>
      </div>

      <div v-if="appUpdated">{{ $t("updates.appUpdated") }}</div>

      <div class="updates-info-container" v-if="getInfo">
        <div class="seperator"></div>
        <div style="padding-top: 15px">
          <div class="title">
            {{
              !appUpdated
                ? $t("updates.whatsNew")
                : $t("about.whatsNewInLatest")
            }}
          </div>
          <div v-for="item in whatsNew" :key="item.version">
            <div class="version">
              {{ $t("updates.update") }} {{ item.version }}
            </div>

            <div class="new-item" v-for="line in item.data" :key="line">
              {{ line }}
            </div>
            <p v-if="item.data.length == 0">{{ $t("about.noData") }}</p>
            <div class="seperator"></div>
          </div>
        </div>
      </div>

      <div>
        <div class="btn btn-small mrg-right mrg-t-12" @click="openErrorLog">
          {{ $t("updates.showLogFile") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from "@/services/_axios";
import { mapState, mapGetters, mapActions } from "vuex";
import menuService from "@/services/menu";
import appUpdates from "@/mixing/appUpdates.js";
export default {
  data() {
    return {
      routeBackName: "tools",
      link: "",
      typedMsg: "",
      updatesInfo: null,
      message: "",
      show: true,
    };
  },
  mixins: [appUpdates],
  props: {
    arrow: { default: true },
  },
  computed: {
    ...mapState("updatesCenter", ["ENUM_UPDATES_STAGES"]),
    ...mapGetters("updatesCenter", [
      "getPercentage",
      "getStage",
      "getVersion",
      "showProgress",
      "getInfo",
      "getInProcess",
      "appUpdated",
      "getExternalNotConnected",
      "getMultiDisk",
      "getQuiet",
    ]),
    whatsNew() {
      if (!this.getInfo) return [];
      return Object.keys(this.getInfo).map((v) => {
        return { version: v, data: this.getInfo[v].whatsNew };
      });
    },
  },
  methods: {
    close() {
      menuService.closeMenu();
    },
  },
  mounted() {
    if (!this.getInProcess) {
      Axios.get("/api/general/get-updates");
    }
  },
};
</script>

<style lang="scss" scoped>
.item {
  padding: 20px;
}
.updates-info-container {
  margin-top: 15px;
}
.title {
  color: #7f7f7f;
  font-weight: bold;
  font-size: 13px;
}
.version {
  color: var(--custom-color1);
  padding-top: 12px;
  padding-bottom: 4px;
}
.new-item {
  padding-right: 9px;
}
</style>
